<template>
   <div class="gens-universes">
       <div class="gens-detail">
           <div class="detail-content">
               <div class="post_image">
                    <img class="post_image_img" src="../../assets/images/gensunicerse/180919-feature-dr-chua.jpg"/>
               </div>
               <div class="post_text">
                   <div class="post_tip">全方位癌症基因分析 突破无药可治的困局</div>
                   <div class="post_info">Posted at 09:00h in 癌症</div>
                    
                    <div class="post_wrapper_1">
                      近年，基因检测技术愈来愈细致和精密，使癌症的治疗由以往的一体化（one size fits all）趋向个人化（individualized）。以晚期肺癌为例，传统的治疗方法离不开化疗，患者对治疗的反应不一。自从医学界掌握了部分肺癌乃由特定的基因变异引起，例如EGFR、ALK或ROS-1等，医生处方针对性的标靶药物，治疗效果和患者的整体存活期均得以提升。
                    </div>
                    <div class="post_wrapper_1">
                     因此，就某些癌症而言，如肺癌和乳癌，基因检测的结果会直接影响治疗方案，故医生一般会在确诊的同时建议患者进行基因检测，把握时间，及早开始用「对」的药。目前最新的基因检测技术「全方位癌症基因分析」有别于传统的「热点基因变异检测」，不仅能找出某种癌症较常见及已知的几种基因变异，例如非小细胞肺癌的EGFR 、ALK或ROS-1，而且能同时进行超过三百个基因排序，检测出导致癌症发生的基因变异(包括基因插入与缺失、复制、扩增和重组)，有助医生为患者配对针对性的标靶药。「全方位癌症基因分析」的另一特色，是报告中会提供整体性资料，例如肿瘤突变负荷（Tumor Mutational Burden, TMB），有助医生评估患者对免疫疗法的反应。一般来说，肿瘤的TMB愈高，患者对免疫疗法的反应愈理想。
                    </div>
                    <div class="post_wrapper_tip">启动智能诊断</div>
                    <div class="post_wrapper_1">
                       现时讲求「精准医疗」（Precision Medicine）与「个人化治疗」（Individualized Treatments）的年代，说穿了就是两个大方向：
                    </div>
                    <div class="post_wrapper_1">
                      1）癌症是一种复杂的疾病，即使同属肺腺癌，每位患者肿瘤的生物特性都有所不同。若采用传统的一体化治疗，可能只对部分患者有效，另一部分患者却得不到最佳的治疗。 「全方位癌症基因分析」就是深入肿瘤的底层找出致癌根源，从而帮助医生对症下药。
                    </div>
                    <div class="post_wrapper_1">
                       2）对于一些较为棘手、缺乏治疗方向的个案，「全方位癌症基因分析」不但能避免患者浪费时间试用一些效果未必理想的药物，另一方面有助医生更科学化和更精准地处方针对性的药物。换句话说，癌症的治疗不再单单根据肿瘤的原发位置，而是针对肿瘤的基因构造和生物特性。
                    </div>
                    <div class="post_wrapper_tip">临床个案分享</div>
                    <div class="post_wrapper_1">
                       现年62岁的男性肺腺癌患者，对化疗的反应欠佳，病情转差。我建议他接受「全方位癌症基因分析」，结果发现他肺部的肿瘤竟出现常见于乳癌的HER2基因扩增。我为他处方针对HER2型乳癌的标靶药物，效果理想，除癌指数稳定回落之外，其体状况亦得到明显改善，扫描显示肿瘤成功受控。患者用药至今超过一年，病情仍然稳定，身体状况和生活质素理想，能出国旅游，享受人生。过往，我们不会为肺癌患者处方乳癌的药物，「全方位癌症基因分析」让医生更有把握地采用常规治疗以外、具针对性而有效的治疗方法，为患者开阔了治疗的可能性。
                    </div>
                    <div class="post_wrapper_tip">蔡医生给患者的话</div>
                    <div class="post_wrapper_1">
                      尽管基因检测并非百分百帮助到患者，但若找到有标靶药可用的基因变异，治疗将会事半功倍。我预期基因检测将会愈来愈普及，价钱亦会有所下调。科技发展一日千里，我鼓励患者对新的检测技术和新的药物抱持开放的态度，给自己多一个机会，常怀希望。
                    </div>

                    
                    <div class="post_wrapper_1">
                        參考資料：<a href="https://skypost.ulifestyle.com.hk/article/2148190/%E3%80%8C%E5%85%A8%E6%96%B9%E4%BD%8D%E7%99%8C%E7%97%87%E5%9F%BA%E5%9B%A0%E5%88%86%E6%9E%90%20%E7%AA%81%E7%A0%B4%E7%84%A1%E8%97%A5%E5%8F%AF%E6%B2%BB%E7%9A%84%E5%9B%B0%E5%B1%80%E3%80%8D">
                       晴报</a>
                    </div>
                    
               </div>
           </div>
           <div class="detail-list-menu">
               <div class="list-menu-item">
                   	<h5>最新資訊</h5>		
                       <ul>
							<li>
					            <a href="#/gensone">無免疫力孕婦的患麻疹 最嚴重可流產</a>
							</li>
							<li>
					            <a href="#/genstwo">無入侵性抽血驗癌症 適宜年老病人</a>
							</li>
							<li>
					            <a href="#/gensthree">最易被忽略的一種過敏食物</a>
							</li>
							<li>
					            <a href="#/gensfour">樂觀女性生仔機會較大</a>
						    </li>
							<li>
					            <a href="#/gensfive">雙胞胎兒竟然是同母異父</a>
							</li>
					</ul>
               </div>
               <div class="list-menu-item">
                   <h5>分類</h5>		
                   <ul>
				       <li>
                           <a href="#/gensuniversecate?categoryName=传染病&isCategory=1">傳染病</a> (2)
                       </li>
                       <li >
                           <a href="#/gensuniversecate?categoryName=天赋基因&isCategory=1">天賦基因</a> (1)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=无创产前检测&isCategory=1">無創產前檢測</a> (2)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=生育健康&isCategory=1">生育健康</a> (4)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=癌症&isCategory=1">癌症</a> (4)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=致敏原&isCategory=1">致敏原</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=亲子鉴定&isCategory=1">親子鑑定</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=遗传病&isCategory=1">遺傳病</a> (1)
                        </li>
                    </ul>
               </div>
           </div>
       </div>
   </div>
</template>
<script>
export default {
    data(){
        return{
          
        }
    },
    mounted(){

    },
    methods:{

    }
}
</script>


<style lang="scss" scoped>
.gens-universes{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    margin-bottom:25px;
    
    font-family: 'Microsoft JhengHei',sans-serif !important;
      margin-top:25px;
    .gens-detail{
        text-align: left;
        margin-top:10px;
        width:57.5%;
        margin:auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .detail-content{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width:66.66%;
            .post_image{
                position: relative;
                width: 100%;
                display: block;
                .post_image_img{
                   max-width: 100%;
                   height: auto; 
                }
            }
            .post_text{
                .post_tip{
                    margin-top:35px;
                    color: #368da7;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 600;
                    letter-spacing: 0;
                    text-transform: none;
                }
                .post_info{
                    display: inline-block;
                    width: 100%;
                    margin: 0 0 18px;
                    color: #bebebe;
                    font-weight: 500;
                    line-height: 27px;
                    font-size: 16px;
    
                }
                .post_wrapper{
                    
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                }
                .post_tip_1{
                    margin-top:35px;
                    border-color: #368da7;
                    background-color: #e9faff;
                    padding: 14px 14px 14px 10px;
                    border-left: 4px solid #368da7;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;

                }
                .post_wrapper_1{
                    margin-top:15px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    ul{
                            list-style-position: inside;
                            display: block;
                            list-style-type: disc;
                            margin-block-start: 1em;
                            margin-block-end: 1em;
                            margin-inline-start: 0px;
                            margin-inline-end: 0px;
                            padding-inline-start: 40px;
                    }
                    li{
                        display: list-item;
                        text-align: -webkit-match-parent;
                    }
                }
                .post_wrapper_2{
                     margin-top:3px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
                .post_wrapper_1 a{
                    color:#368da7;
                    text-decoration: none;
                }
                .post_wrapper_1 a:hover{
                    color:#9bd9dd;;
                    text-decoration: none;
                }
                .post_wrapper_tip{
                    margin-top:35px;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    text-transform: none;
                    color: #368da7;
                }
                .post_wrapper_tip_c{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    margin-top:10px;
                    letter-spacing: .07em!important;
                }
                .post_wrapper_img{
                    margin-top:35px;
                    text-align: center;
                    img{
                        vertical-align: middle;
                        height: auto;
                        max-width: 100%;
                    }
                    .bottom_tip{
                        margin-top: .2em;
                       font-size: .8em;
                    }
                }
            }
            
        }
        .detail-list-menu{
            width: 33.33%;
            display: flex;
            padding-left:40px;
            justify-content: left;
            align-items: flex-start;
            flex-direction: column; 
            align-self: flex-start;
            .list-menu-item{

                width:100%;
                background-color: #f3f3f3!important;
                padding: 14px!important;
                box-shadow: 4px 4px 5px #cfcfcf;
                margin: 0 0 42px;
            }
            .list-menu-item h5{
                 color: #368da7!important;
                 font-size: 18px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
            }
            .list-menu-item ul{
                list-style: none;
                padding: 0;
                background: 0 0;
                border: 0;
                margin: 0;
                padding: 0;
                vertical-align: baseline;
                outline: 0;
                color: #3b3b3b;
            }
            .list-menu-item li{
                line-height: 27px;
                letter-spacing: .07em!important;
                font-size: 14px;
                padding: 5px 0;
                margin: 0;
                vertical-align: baseline;
            }
            .list-menu-item a{
                
                text-decoration: none;
                color:  #303030 !important;
                font-weight: 400;
            }
            .list-menu-item a:hover{
                color: #9bd9dd !important;
                font-weight: 400;
            }
        }
    }

           
}
</style>


// WEBPACK FOOTER //
// src/view/gensuniversedetail/gensseven.vue